import * as React from 'react';

import { Button, Loading, color } from '@coursera/coursera-ui';

import { getManageProgramLearnersLink } from 'bundles/enterprise-admin-navigation/utils/AdminNavigationUtils';
import { useProgramData } from 'bundles/enterprise-legacy-learner-home/hooks/useProgramData';

import _t from 'i18n!nls/enterprise-legacy-learner-home';

type Props = {
  programId: string;
};

/**
 * Consolidate all program admin related logic that's living at program home
 * Currently only the invitation link. But may add more later
 */
export const ProgramAdminActions: React.FC<Props> = ({ programId }) => {
  const { loading, error, programSlug, orgSlug } = useProgramData(programId);

  if (loading) {
    return <Loading />;
  }

  if (error || !programSlug || !orgSlug) {
    return null;
  }

  const programInvitationUrl = getManageProgramLearnersLink(
    {
      programSlug,
      thirdPartySlug: orgSlug,
    },
    undefined,
    false
  );

  return (
    <div className="vertical-box align-items-left">
      {programInvitationUrl && (
        <span>
          <Button
            type="primary"
            tag="a"
            label={_t('Go to Invitations')}
            style={{
              backgroundColor: color.admin,
              borderColor: color.admin,
            }}
            htmlAttributes={{
              href: programInvitationUrl,
              target: '_blank',
              rel: 'noopener noreferrer',
            }}
          />
        </span>
      )}
      <p className="m-b-0 font-sm text-secondary font-italic">
        {_t('You do not have full access to this program. To join, send yourself an invitation.')}
      </p>
    </div>
  );
};

export default ProgramAdminActions;
